import { render, staticRenderFns } from "./ShopDateEvent.vue?vue&type=template&id=40d5645c&"
import script from "./ShopDateEvent.vue?vue&type=script&lang=js&"
export * from "./ShopDateEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ShopDateEvent.vue"
export default component.exports